import { CnpjValidator } from '../../../shared/utils/validators/cnpj-validator';
import { Component, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { cnpj, cpf } from "cpf-cnpj-validator";
import { MDBModalRef } from "ng-uikit-pro-standard";
import { Empresa, Representantes } from "src/app/auth/models/empresa.model";
import { ISignUpEmpresas } from "src/app/auth/models/register.model";
import { CadastroService } from "src/app/auth/services/cadastro.service";
import {
  showSucess,
  showDefaultError,
  showError,
  showErrorViaArray,
} from "src/app/shared/utils/functions/notification.function";
import { emailValidator } from "src/app/shared/utils/validators/forms.validators";

@Component({
  selector: "app-modal-editar-empresas",
  templateUrl: "./modal-editar-empresas.component.html",
  styleUrls: ["./modal-editar-empresas.component.scss"],
})
export class ModalEditarEmpresasComponent implements OnInit {
  closeCallback: () => void;
  mdbRef: MDBModalRef;
  model: any;

  formEmpresa: FormGroup;

  constructor(
    public modalRef: MDBModalRef,
    private cadastroService: CadastroService
  ) {}

  ngOnInit(): void {
    this.createFormArrayEmpresa(this.model.empresas, true);
  }

  updateEmpresa() {
    if (this.validateFormEmpresa()) {
      const body: ISignUpEmpresas = {
        documentoIdentificador: this.model.documentoIdentificador,
        empresas: this.formEmpresa.getRawValue().empresas.map((emp) => ({
          cnpj: emp.cnpj,
          nomeEmpresa: emp.nomeEmpresa,
          representantes: emp.representantes.map((rep) => ({
            nome: rep.nome,
            cpf: rep.cpf,
            emailPj: rep.emailPj,
          })),
        })),
      };

      this.cadastroService.efetuarCadastroEmpresas(body).subscribe(
        (res) => {
          this.closeModal();
          return showSucess("", "Atualizado com Sucesso.");
        },
        (e) => {
          if (e) {
            const errors = e?.error?.descricaoErro || [];
            return showErrorViaArray("", errors);
          } else {
            return showError(
              "",
              "Ocorreu um erro na solicitação, por favor tente novamente em alguns instantes."
            );
          }
        }
      );
    }
  }


  //Valida FORMS
  private validateFormEmpresa(): boolean {
    const cnpjs: string[] = [];

    const empresas = this.formEmpresa.get("empresas") as FormArray;

    for (let e = 0; e < empresas.length; e++) {
      const emp = empresas.at(e) as FormGroup;
      const cnpjValue = emp.get("cnpj")?.value;

      // Contêm os valores dos representates de uma determinada empresa.
      const nomes: string[] = [];
      const cpfs: string[] = [];
      const emails: string[] = [];

      // Validação de CNPJ
      let cnpjValido = cnpjValue;

      try {
        cnpjValido = CnpjValidator.create(cnpjValue);
        emp.get("cnpj")?.setValue(cnpjValido);
      } catch {
        showError("", `O CNPJ do Credor Pessoa Jurídica na posição ${e + 1} não é válido.`);
        return false;
      }

      if (cnpjs.includes(cnpjValido)) {
        showError("", `O CNPJ ${this.formatarCNPJ(cnpjValido)} está duplicado!`);
        return false;
      }
      cnpjs.push(cnpjValido);

      // Validação de Razão Social
      if (emp.get("nomeEmpresa")?.hasError("required")) {
        showError(
          "",
          `O campo Razão Social do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
        );
        return false;
      }

      if (emp.get("nomeEmpresa")?.hasError("pattern")) {
        showError(
          "",
          `O campo Razão Social do Credor Pessoa Jurídica ${e + 1} contém caracteres inválidos.`
        );
        return false;
      }

      const representantes = emp.get("representantes") as FormArray;
      const emailRegex = /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

      // Validação dos Representantes
      for (let i = 0; i < representantes.length; i++) {
        const rep = representantes.at(i) as FormGroup;
        const nome = rep.get("nome")?.value?.toLowerCase()?.trim();
        const cpfRep = rep.get("cpf")?.value?.trim();
        const emailPj = rep.get("emailPj")?.value?.toLowerCase()?.trim();

        if (i === 0) {
          if (!nome || nome.length === 0) {
            showError(
              "",
              `O nome do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
            );
            return false;
          }
          if (!cpfRep || cpfRep.length === 0 || !cpf.isValid(cpfRep)) {
            showError(
              "",
              `O CPF do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é inválido ou não foi preenchido.`
            );
            return false;
          }
          if (!emailPj || emailPj.length === 0) {
            showError(
              "",
              `O email do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
            );
            return false;
          }
        }

        if (emailPj && !emailRegex.test(emailPj)) {
          showError(
            "",
            `O email do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é inválido.`
          );
          return false;
        }

        if (cpfRep && !cpf.isValid(cpfRep)) {
          showError(
            "",
            `O CPF do Representante Legal na posição ${i + 1} do Credor Pessoa Jurídica ${
              e + 1
            } é inválido.`
          );
          return false;
        }

        if (cpfRep && cpfs.includes(cpfRep)) {
          showError(
            "",
            `O CPF do Representante Legal "${cpfRep}" na posição ${
              i + 1
            } do Credor Pessoa Jurídica ${e + 1} está duplicado.`
          );
          return false;
        }

        if (cpfRep) cpfs.push(cpfRep);

        if (nome && nomes.includes(nome)) {
          showError(
            "",
            `O nome do Representante Legal "${nome}" na posição ${i + 1} do Credor Pessoa Jurídica ${
              e + 1
            } está duplicado.`
          );
          return false;
        }

        if (nome) nomes.push(nome);

        if (emailPj && emails.includes(emailPj)) {
          showError(
            "",
            `O email do Representante Legal "${emailPj}" na posição ${
              i + 1
            } do Credor Pessoa Jurídica ${e + 1} está duplicado.`
          );
          return false;
        }

        if (emailPj) emails.push(emailPj);
      }
    }

    return true;
  }

  //Criação Formulário de Empresa para o formulário PJ
  createFormArrayEmpresa(value: Empresa[], disabled: boolean = false) {
    const formArray =
      (this.formEmpresa?.get("empresas") as FormArray) || new FormArray([]);

    if (value && value.length > 0) {
      value.forEach((v) => {
        formArray.push(this.createFormEmpresa(v, disabled));
      });
    }

    this.formEmpresa = new FormGroup({
      empresas: formArray,
    });
  }

  createFormEmpresa(value?: Empresa, disabled?: boolean) {
    return new FormGroup({
      add: new FormControl(true),
      delete: new FormControl(!disabled),
      cnpj: new FormControl({ value: value?.cnpj || "", disabled }, [
        Validators.required,
      ]),
      nomeEmpresa: new FormControl(
        { value: value?.nomeEmpresa || "", disabled },
        [Validators.required, Validators.pattern(/^[^!"?\[\\\]‘’“”«»–.]*$/)]
      ),
      representantes: new FormArray([
        this.createFormRepresentantes(value?.representantes?.[0], disabled, true),
        this.createFormRepresentantes(value?.representantes?.[1], disabled, false),
      ]),
    });
  }

  createFormRepresentantes(value?: Representantes, disabled?: boolean, isRequired = true) {
    const validarNome = isRequired ? [Validators.required, Validators.minLength(3)] : [Validators.minLength(3)];
    const validarCpf = isRequired ? [Validators.required, Validators.minLength(11), Validators.maxLength(14)] : [Validators.minLength(11), Validators.maxLength(14)];
    const validarEmail = isRequired ? [Validators.required, Validators.maxLength(50), emailValidator] : [Validators.maxLength(50), emailValidator];

    return new FormGroup({
      delete: new FormControl(!disabled),
      nome: new FormControl({ value: value?.nome || "", disabled }, validarNome),
      cpf: new FormControl({ value: value?.cpf || "", disabled }, validarCpf),
      emailPj: new FormControl({ value: value?.emailPj || "", disabled }, validarEmail),
    });
  }

  get empresas(): FormArray {
    return this.formEmpresa.get("empresas") as FormArray;
  }

  addEmpresa(): void {
    this.empresas.push(this.createFormEmpresa());
  }

  removeEmpresa(index: number): void {
    this.empresas.removeAt(index);
  }

  getRepresentantes(empresaIndex: number): FormArray {
    return this.empresas.at(empresaIndex).get("representantes") as FormArray;
  }

  closeModal() {
    if (this.closeCallback) {
      this.closeCallback();
    }

    return this.modalRef.hide();
  }

  formatarCNPJ(cnpj: string): string {
    if (!cnpj) return '';
    const numerosCnpj = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    if (numerosCnpj.length !== 14) {
      return cnpj;
    }

    return numerosCnpj.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})$/,
      '$1.$2.$3/$4-$5'
    );
  }
}
